import logo from "~/assets/logo.png";

import { Link } from "react-router";
import React, { useRef, useState } from "react";
import { User } from "~/types/generated/proto/db/models/User";
// https://github.com/rosskhanas/react-qr-code/issues/251
// @ts-ignore
import { QRCode } from "react-qr-code";

type NavBarProps = {
	user: User | null
}

export default function NavBar(props: NavBarProps) {
	const navbarMenu = useRef();
	const [dropdownHidden, setDropdownHidden] = useState(false);

	const toggleNavbar = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
		if (navbarMenu.current) {
			navbarMenu.current.classList.toggle("is-active");
			e.currentTarget.classList.toggle("is-active");
		}
	};

	const toggleDropdown = () => {
		setDropdownHidden(!dropdownHidden);
	};

	return (
		<div className="navbar is-primary is-spaced">
			<div className="navbar-brand">
				<Link className="navbar-item" to="/">
					<img src={logo} />
				</Link>
				<div onClick={(e) => toggleNavbar(e)} role="button" className="navbar-burger has-text-dark" data-target="navMenu" aria-label="menu" aria-expanded="false">
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
				</div>
			</div>
			<div className="navbar-menu" ref={navbarMenu}>
				<div className="navbar-end">
				</div>
				<div className="navbar-end">
					{
						props.user ?
							<>
								<Link className="navbar-item has-text-dark" to={"/tools"}>
									<span className="icon has-text-dark is-large">
										<i className="ri-tools-line ri-lg"></i>
									</span>
									Tools
								</Link>
								<Link className="navbar-item has-text-dark" to={"/athletes"}>
									<span className="icon has-text-dark is-large">
										<i className="ri-riding-line ri-lg"></i>
									</span>
									Sportler
								</Link>
								<Link className="navbar-item has-text-dark" to={"/settings"}>
									<span className="icon has-text-dark is-large">
										<i className="ri-settings-2-line ri-lg"></i>
									</span>
									Einstellungen
								</Link>
								<div className="navbar-item has-dropdown is-hoverable">
									<a className="navbar-link has-text-dark is-arrowless">
										<span className="icon has-text-dark is-large">
											<i className="ri-user-line ri-lg"></i>
										</span>
										{props.user.username}
									</a>

									<div className="navbar-dropdown is-right">
										<Link className="navbar-item" to={"/auth/logout"}>
											Ausloggen
										</Link>
										{props.user.totpKeyUri ?
											<>
												<hr className="navbar-divider" />
												<div className="navbar-item">
													<QRCode size={90} value={props.user.totpKeyUri} />
												</div>
											</>
											: <></>
										}
									</div>
								</div>
							</>
							: <></>
					}
				</div>
			</div>
		</div >
	);
}